module.exports = __webpack_public_path__ + "static/media/website-togetherwevote.d5d523f7.png";